import type { EnvironmentProviders } from '@angular/core';
import { makeEnvironmentProviders } from '@angular/core';

/**
 * Mantido por compatibilidade com `app.config.ts`. Com a remoção do motor AG Grid,
 * o `GridRegistry` não é mais necessário. Retorna um conjunto de providers vazio.
 */
export function provideCompanyDataGrid(): EnvironmentProviders {
  return makeEnvironmentProviders([]);
}
